export const digitsOnly = (s: string): string => s.replace(/\D/g, "");

export function isValidGtin(digits: string): boolean {
  if (!/^\d+$/.test(digits) || ![8, 12, 13, 14].includes(digits.length)) return false;
  let sum = 0;
  const body = digits.slice(0, -1);
  for (let i = 0; i < body.length; i += 1) {
    const d = Number(body[body.length - 1 - i]);
    sum += i % 2 === 0 ? d * 3 : d;
  }
  return (10 - (sum % 10)) % 10 === Number(digits[digits.length - 1]);
}

export const looksLikeGtin = (input: string): boolean => /^\d{6,14}$/.test(digitsOnly(input));

// A UPC-E/EAN-8 hint means the server will normalise (expand) the raw code itself, so the
// client's plain GTIN-8/12/13/14 check-digit test — which isn't the right algorithm for a raw
// UPC-E code — must be skipped. Without a hint, keep rejecting client-side as before.
export function shouldRejectClientSide(gtin: string, hint: "upc_e" | "ean_8" | undefined): boolean {
  if (hint) return false;
  return !isValidGtin(gtin) && gtin.length !== 6 && gtin.length !== 7;
}
